"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.printVersion = exports.cliVersion = void 0;
const chalk_1 = __importDefault(require("chalk"));
const package_json_1 = require("@datadog/datadog-ci-base/package.json");
const constants_1 = require("./constants");
const env_1 = require("./helpers/env");
exports.cliVersion = package_json_1.version;
/**
 * Logs the version in all commands, except version commands. Routed through the
 * logger so it respects `--log-format` (a JSON line in JSON mode, dim text otherwise).
 *
 * Suppressed entirely when `DD_CI_SKIP_VERSION_BANNER` is `1`/`true`, for callers
 * that find the per-invocation banner too noisy.
 */
const printVersion = (logger) => {
    if ((0, env_1.toBoolean)(process.env[constants_1.SKIP_VERSION_BANNER_ENV_VAR])) {
        return;
    }
    const lastArg = process.argv.at(-1);
    const skipVersion = lastArg === '--version' || lastArg === 'version' || lastArg === '--help';
    if (skipVersion) {
        return;
    }
    const banner = `datadog-ci v${exports.cliVersion}`;
    logger.info(logger.isJsonOutput() ? banner : chalk_1.default.dim(banner));
};
exports.printVersion = printVersion;
//# sourceMappingURL=version.js.map